import { IBaseDataParser } from "../../../../vendor_core/core/src/server/parsers/IBaseDataParser";
import ILoginData from "../../../src/server/data/ILoginData";
import GameModel from "../../../core/src/model/GameModel";
import SpinModel from "../../../core/src/model/SpinModel";
import BetModel from "../../../core/src/model/BetModel";
import ConfigManager from "../../../core/src/managers/ConfigManager";
import { ConfigurationTypes } from "../../../core/src/const/ConfigurationTypes";
import App from "../../../core/src/App";

export default class LoginDataParser implements IBaseDataParser<ILoginData> {
    private jackpotRestoreTest =
        "{\"generation\":0,\"roundFinished\":true,\"restoreVersion\":3,\"freespinSelectScreen\":null,\"featureMode\":null}";
    check(data: any): boolean {
        return data.stats && data.sid;
    }

    parse(data: ILoginData): any[] {
        // data.refresh.symbols.push(data.refresh.bonusReel);
        let restoreData = null;
        if (data.refresh) {
            if (data.refresh.restoreState === undefined && data.refresh?.jackpotPickerResults) {
                GameModel.restoreData = this.jackpotRestoreTest;
            } else {
                GameModel.restoreData = data.refresh.restoreState;
            }
            // GameModel.restoreData = data.refresh.restoreState;
            restoreData = this.parseRestoreData(GameModel.restoreData);
            SpinModel.freespinSelectScreen = restoreData?.freespinSelectScreen || null;
            if (restoreData?.featureMode != undefined) {
                SpinModel.featureMode = restoreData.featureMode;
            } else {
                SpinModel.featureMode = -1;
            }
        }
        BetModel.betDivisor = data.config.creditsPerBet || 1;
        const result = {
            balance: data.stats.b,
            currency: data.stats.currency,
            sessionID: data.sid,
            serverGameConfig: this.parseGameConf(data),
            country: data.country,
            denomination: data.betMultiplier,
            coinSize: data.limits.defaultBet,
            coinSizeIndex: data.limits.legalBets.indexOf(
                data.limits.defaultBet
            ),
            creditValues: data.limits.legalBets,
            betMultiplier: data.betMultiplier || 1,
            restoreVersion: restoreData ? restoreData?.restoreVersion + 1 : 1,
            restoreData,
            betMultipliers: this.parseBetMultipliers(data.limits.legalBets),
            betMultiplierMin: data.limits.legalBets[0] / data.limits.defaultBet,
            betMultiplierMax:
                data.limits.legalBets[data.limits.legalBets.length - 1] /
                data.limits.defaultBet,
            numLines: 1,
        };

        return [result];
    }

    parseRestoreData(restoreState: string): any {
        if (restoreState) {
            return JSON.parse(restoreState);
        }
        return null;
    }

    private parseBetMultipliers(bets) {
        let result = [];

        let minBet = Math.min.apply(Math, bets);

        for (let i = 0; i < bets.length; i++) {
            result[i] = bets[i] / minBet;
        }
        return result;
    }

    private parseGameConf(data) {
        let result = {
            paylines: data.config.paylines || App.config.paylines,
            paytable: data.config.paytable,
        };
        return result;
    }
}
